module.exports = __webpack_public_path__ + "static/media/DS_DZHR1_201907200653149_KZ1_E066N50_017688_QL.2363daa0.webp";